import { render, staticRenderFns } from "./Hashtag.vue?vue&type=template&id=848537be&"
import script from "./Hashtag.vue?vue&type=script&lang=js&"
export * from "./Hashtag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports